import { createRequestHelper } from '@utils/swr'
import queryString from 'query-string'
import { type PopupCandidatesQueryParams } from '../types/apiRequest'
import { type PopupCandidatesResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['popupCandidates'], PopupCandidatesResponse, PopupCandidatesQueryParams>({
  client: 'eCommerce',
  key: (params) => {
    const queryParamsObject = {
      campaign_id: params?.campaign_id,
      country_code: params?.country_code,
      project_code: params?.project_code,
    }
    const query = queryString.stringify(queryParamsObject, {
      skipNull: true,
      skipEmptyString: true,
    })
    const queryParams = query ? `?${query}` : ''
    return `/popups/popup-candidates${queryParams}`
  },
})

export const useApiPopupCandidates = useRequest
